export let timestampBins = [
    { name: 'year', value: 'year'},
    { name: 'month', value: 'month,year'},
    { name: 'week', value: 'year,week'},
    { name: 'day', value: 'date'}
]; 

export let numberAggregations = [
    'min',
    'max',
    'avg',
    'sum'
]; 

export let stringAggregations = [
    'count unique'
];

export let enumAggregations = [
    'count unique'
];

export let entityOperations = [
    'within',
    "in",
    'eq'
]; 

export let stringOperations = [
    'eq',
    'contains'
]; 

export let enumOperations = [
    'eq',
    'contains'
]; 

export let numberOperations = [
    'gt',
    'gte',
    'lt',
    'lte',
    'eq',
    'between'
]; 

export let timeOperations = [
    'gt',
    'gte',
    'lt',
    'lte',
    'eq'
]; 
